<template>
    <div style="display: inline-block;" :class="className">
        <span @click.stop="visible=true">
            <slot></slot>
        </span>
        <el-dialog
            :visible.sync="visible"
            :append-to-body="true"
            :custom-class="'dialogAddress'"
            title="添加安装公司"
        >
            <el-form ref="form" :rules="rules" :model="formData" >
                <el-form-item label="公司名称：" prop="company_name">
                    <el-input v-model="formData.company_name"></el-input>
                </el-form-item>
                <el-form-item label="公司简介：" prop="company_profile" >
                    <el-input :rows="3" type="textarea" placeholder="公司简介" v-model="formData.company_profile"></el-input>
                </el-form-item>
                <el-form-item label="公司编号：" prop="company_sn">
                    <el-input v-model="formData.company_sn"></el-input>
                </el-form-item>
                <el-form-item label="联系人：" prop="company_contact">
                    <el-input v-model="formData.company_contact"></el-input>
                </el-form-item>
                <el-form-item label="联系方式：" prop="company_tel">
                    <el-input v-model="formData.company_tel"></el-input>
                </el-form-item>
                <el-form-item label="结算价格：" prop="settlement_price">
                    <el-input v-model="formData.settlement_price"></el-input>
                </el-form-item>
                <el-form-item class="address" label="公司地址：">
                    <el-select v-model="formData.province" placeholder="省份">
                        <el-option
                            v-for="{region_id, region_name} in provinceList"
                            :key="region_id"
                            :value="region_id"
                            :label="region_name"
                        >
                        </el-option>
                    </el-select>
                    <el-select v-model="formData.city" placeholder="城市">
                        <el-option
                            v-for="{region_id, region_name} in cityList"
                            :key="region_id"
                            :value="region_id"
                            :label="region_name"
                        ></el-option>
                    </el-select>
                    <el-select v-model="formData.district" placeholder="区">
                        <el-option
                            v-for="{region_id, region_name} in districtList"
                            :key="region_id"
                            :value="region_id"
                            :label="region_name"
                        ></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item label="登录帐号：" prop="login_account">
                    <el-input v-model="formData.login_account"></el-input>
                </el-form-item>
                <el-form-item label="登录密码：" prop="login_password">
                    <el-input v-model="formData.login_password"></el-input>
                </el-form-item>
                <el-form-item label="备注：" prop="remarks">
                    <el-input v-model="formData.remarks"></el-input>
                </el-form-item>
                <el-form-item label="公司状态：" class="address" >
                    <el-select v-model="formData.status" placeholder="公司状态">
                            <el-option value="0" label="正常"></el-option>
                            <el-option value="1" label="停用"></el-option>
                    </el-select>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="changeAddr" :loading="btnLoading">确定
                    </el-button>
                    <el-button @click="visible=false">取消</el-button>
                </el-form-item>
            </el-form>
        </el-dialog>
    </div>
</template>

<script>
    import { getAddressSelect, changeAddress, postAppointment, session_id } from '../../stores/api';
    import { mapState } from 'vuex';

    export default {
        props: ['get_staff_position_list'],
        data () {
            return {
                btnLoading: false,
                visible: false,
                formData: {
                    company_name: '',
                    company_profile: '',
                    company_contact: '',
                    company_sn: '',
                    company_tel: '',
                    province: '',
                    city: '',
                    district: '',
                    login_account: '',
                    login_password: '',
                    remarks: '',
                    settlement_price: '',
                    status: '',
                },
                cityList: [],
                districtList: [],
                //dialog校验
                rules: {
                    company_name: [{required: true, message: '请输入公司名称', trigger: 'blur'}],
                    company_profile: [{required: true, message: '请输入公司简介', trigger: 'blur'}],
                    settlement_price: [{required: true, message: '请输入结算价格', trigger: 'blur'}],
                    company_sn: [{required: true, message: '请输入公司编号', trigger: 'blur'}],
                    company_contact: [{required: true, message: '请输入联系人', trigger: 'blur'}],
                    company_tel: [{required: true, message: '请输入公司联系方式', trigger: 'blur'}],
                    login_account: [{required: true, message: '请输入登录帐号', trigger: 'blur'}],
                    login_password: [{required: true, message: '请输入登录密码', trigger: 'blur'}],
                }
            };
        },
        methods: {
            async getCityList (id) {
                return getAddressSelect(id).then((res) => {
                    this.cityList = res.data;
                    return res.data;
                });
            },
            async getDistrictList (id) {
                return getAddressSelect(id).then(res => {
                    this.districtList = res.data;
                    return res.data;
                });
            },
            changeAddr () {
                this.$refs.form.validate(async (valid) => {
                    if (valid) {
                        // this.btnLoading = true;
                        //&company_name=${self.company_name}&company_profile=${self.company_profile}&company_sn=${self.company_sn}&company_tel=${self.company_tel}&province=${self.province}&city=${self.city}&district=${self.district}&remarks=${self.remarks}&login_account=${self.login_account}&login_password=${self.login_password}&session_id=`+session_id
                        this.$http.get(this.$reqUrl + `service.php?act=company_insert&company_name=${this.formData.company_name}&settlement_price=${this.formData.settlement_price}&company_profile=${this.formData.company_profile}&company_sn=${this.formData.company_sn}&company_contact=${this.formData.company_contact}&company_tel=${this.formData.company_tel}&province=${this.formData.province}&city=${this.formData.city}&district=${this.formData.district}&remarks=${this.formData.remarks}&login_account=${this.formData.login_account}&login_password=${this.formData.login_password}&status=${this.formData.status}&session_id=` + localStorage.getItem('azgs_session_id')).then(res => {
                                if(0==res.data.error){
                                    this.$message.success('添加成功')
                                    // this.btnLoading = false;
                                    this.visible = false;
                                    this.get_staff_position_list()
                                }
                                if(1==res.data.error){
                                    this.$message.error(res.data.msg)
                                }
                            }).catch(res => {
                            this.$message.error('请求失败')
                        })
                        // //预约安装
                        // if (this.type === 3) {
                        //     await this.setAppointment();
                        //     this.btnLoading = false;
                        //     this.visible = false;
                        //     return;
                        // }
                        // //修改订单地址
                        // if (this.type === 4) {
                        //     await this.editOrderAddress();
                        //     this.btnLoading = false;
                        //     this.visible = false;
                        //     return;
                        // }
                        // changeAddress(this.formData).then(async (res) => {
                        //     localStorage.setItem('address_id', res.data.address_id)
                        //     await this.getAddress();
                        //     this.$notify.success({
                        //         title: '操作成功',
                        //         message: `${this.type === 1 ? '修改' : '添加'}地址成功`,
                        //     });
                        // }).catch((err) => {
                        //     this.$notify.error({
                        //         title: '操作失败',
                        //         message: err.message,
                        //     });
                        // }).then(() => {
                        //     this.btnLoading = false;
                        //     this.visible = false;
                        //     //添加完后清空信息
                        //     if (this.type === 2) {
                        //         Object.assign(this.formData, {
                        //             consignee: '',
                        //             mobile: '',
                        //             address: ''
                        //         });
                        //     }
                        // });
                    }
                });
            },
            //预约安装
            async setAppointment () {
                const {district, province, city, ...rest} = this.formData;
                postAppointment({
                    city_checked_id: city,
                    district_checked_id: district,
                    province_checked_id: province,
                    order_sn: this.order.order_sn,
                    yuyue_time: this.time,
                    ...rest,
                }).then(() => {
                    this.$notify.success({
                        title: '操作成功',
                        message: `已预约安装`,
                    });
                    this.order.is_yuyue = 1;
                    this.order.consignee = this.formData.consignee;
                }).catch(err => {
                    this.$notify.error({
                        title: '操作失败',
                        message: err.message,
                    });
                    this.btnLoading = false;
                });
            },
            //修改订单地址
            async editOrderAddress () {
                const {district, province, city, ...rest} = this.formData;
                postAppointment({
                    city_checked_id: city,
                    district_checked_id: district,
                    province_checked_id: province,
                    order_sn: this.order.order_sn,
                    ...rest,
                }).then(() => {
                    this.$notify.success({
                        title: '操作成功',
                        message: `已修改地址`,
                    });
                    const {address, province, city, district} = this.formData;
                    const provinceStr = this.provinceList.find(p => p.region_id === province).region_name;
                    const cityStr = this.cityList.find(c => c.region_id === city).region_name;
                    const districtStr = this.districtList.find(d => d.region_id === district).region_name;
                    this.$emit('update:editData', {
                        ...this.editData,
                        ...this.formData,
                        address_str: `${provinceStr},${cityStr},${districtStr} ${address}`,
                    });
                }).catch(err => {
                    this.$notify.error({
                        title: '操作失败',
                        message: err.message,
                    });
                    this.btnLoading = false;
                });
            }
        },
        watch: {
            'formData.province': async function (val, oldVal) {
                const data = await this.getCityList(val);
                if (data.length > 0) {
                    this.formData.city = data[0].region_id;
                }
            },
            'formData.city': async function (val, oldVal) {
                const data = await this.getDistrictList(val);
                if (data.length > 0) {
                    this.formData.district = data[0].region_id;
                }
            },
            async visible (val) {
                if (val) {
                    if (this.type === 1) {
                        this.getCityList(this.formData.province);
                        this.getDistrictList(this.formData.city);
                    } else {
                        const provinces = await this.getCityList(this.provinceList[0].region_id);
                        const districts = await this.getDistrictList(provinces[0].region_id);
                        this.formData.province = this.provinceList[0].region_id;
                        this.formData.city = provinces[0].region_id;
                        this.formData.district = districts[0].region_id;
                    }
                }
            },
            editData (val) {
                if (this.type === 3) {
                    const {province_checked_id, city_checked_id, district_checked_id, ...rest} = val;
                    this.formData = {
                        province: province_checked_id,
                        city: city_checked_id,
                        district: district_checked_id,
                        ...rest
                    };
                } else {
                    this.formData = {...val};
                }
            }
        },
        computed: {
            ...mapState(['provinceList']),
        }
    };
</script>
<style lang="less">
    .dialogAddress {
        width: 600px;
        .el-dialog__header {
            display: flex;
            justify-content: center;
            border-bottom: 1px solid #C7C7C7;
        }
        .el-dialog__body {
            padding: 30px 90px 30px 70px;
            .address > .el-form-item__content {
                display: flex;
                & > div {
                    margin-right: 8px;
                }
            }
            .el-form-item {
                .el-form-item__label {
                    width: 100px !important;
                    font-size: 14px;
                }
                .el-form-item__content {
                    margin-left: 100px !important;
                    .el-select {
                        .el-input__inner {
                            font-size: 12px;
                            padding: 0 8px;
                        }
                    }
                }
            }
            .additional {
                .el-form-item__content {
                    margin-left: 30px !important;
                    background: #f5f5f5;
                    & > div {
                        padding: 8px 0;
                        .el-button + .el-button {
                            margin-left: 0;
                        }
                        display: flex;
                        justify-content: space-around;
                        flex-wrap: wrap;
                        button {
                            padding: 10px;
                            margin-bottom: 5px;
                            border-radius: 2px;
                            background: transparent;
                            color: #2795f5;
                            font-size: 12px;
                            border: 1px solid transparent;
                            &:hover {
                                border-color: #2795f5 !important;
                            }
                        }
                    }

                }
            }

        }
    }
</style>



// WEBPACK FOOTER //
// src/components/InstallationCompany/AddCompany.vue